module.exports = __webpack_public_path__ + "img/sidebar.f9ad26e8.png";